import { __decorate } from "tslib";
import { AsnProp } from "@peculiar/asn1-schema";
import { LogotypeAudio } from "./logotype_audio";
import { LogotypeImage } from "./logotype_image";
export class LogotypeData {
    constructor(params = {}) {
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: LogotypeImage, repeated: "sequence", optional: true })
], LogotypeData.prototype, "image", void 0);
__decorate([
    AsnProp({ type: LogotypeAudio, repeated: "sequence", context: 1, optional: true })
], LogotypeData.prototype, "audio", void 0);
